import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Repeat, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WeeklyOngoingToggle = ({ booking, token, onSaved }) => {
  const [busy, setBusy] = useState(false);
  if (booking.status === "cancelled") return null;
  const wr = booking.weekly_rolling || {};
  const on = !!wr.enabled;
  const today = new Date().toISOString().slice(0, 10);
  const paidThrough = (wr.paid_through || "").slice(0, 10);
  const needsAnchor = on && !paidThrough;
  const overdue = on && paidThrough && paidThrough < today;

  const toggle = async () => {
    let rate = Number(wr.agreed_rate) || 0;
    let paidThroughInput = paidThrough;
    if (!on) {
      if (!window.confirm(`Turn ON Ongoing Weekly Rental for ${booking.name}?\n\nThis marks them as a long-term weekly renter with no fixed return date — the vehicle stays unavailable and overdue tracking is paused until an actual return, regardless of the return date on file. No charge, invoice or payment link is ever created automatically.`)) return;
      const v = window.prompt(`Agreed weekly rate for reference (optional — leave blank to skip):`, rate ? String(rate) : "250");
      if (v !== null && v.trim() !== "") {
        const n = Number(v);
        if (!Number.isNaN(n) && n >= 0) rate = n;
      }
      const d = window.prompt(`Paid-through / next-billing date (YYYY-MM-DD), optional — leave blank if not yet known. Overdue tracking stays paused until you set this.`, "");
      if (d !== null && d.trim() !== "") paidThroughInput = d.trim();
    } else if (!window.confirm(`Turn OFF Ongoing Weekly Rental for ${booking.name}?\n\nOverdue tracking will resume using the return date on file.`)) return;
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/bookings/${booking.id}/weekly-rolling`,
        { enabled: !on, agreed_rate: rate, paid_through: paidThroughInput || "" },
        { headers: { Authorization: `Bearer ${token}` } });
      toast.success(!on
        ? `Ongoing Weekly Rental is ON${data.weekly_rolling.agreed_rate ? ` — $${Number(data.weekly_rolling.agreed_rate).toFixed(0)}/week` : ""}${data.needs_billing_anchor ? ". No paid-through date set yet — set it when known." : ` — paid through ${data.weekly_rolling.paid_through}.`}`
        : "Ongoing Weekly Rental turned OFF.");
      onSaved?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not update Ongoing Weekly Rental.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button data-testid={`weekly-rolling-toggle-${booking.id}`} onClick={toggle} disabled={busy}
      className={`text-xs flex items-center gap-1.5 px-3 py-1.5 rounded border transition-colors disabled:opacity-50 ${overdue
        ? "border-red-500 bg-red-500/15 text-red-300 hover:brightness-125"
        : needsAnchor
          ? "border-amber-400 bg-amber-400/10 text-amber-300 hover:brightness-125"
          : on
            ? "border-sky-400 bg-sky-400/15 text-sky-300 hover:brightness-125"
            : "border-white/20 text-white/60 hover:border-sky-400/60 hover:text-sky-300"}`}>
      {busy ? <Loader2 className="animate-spin" size={13} /> : <Repeat size={13} />}
      {on
        ? `Ongoing Weekly${wr.agreed_rate ? `: $${Number(wr.agreed_rate).toFixed(0)}/wk` : ""}${overdue ? " — PAST PAID-THROUGH" : needsAnchor ? " — set billing anchor" : paidThrough ? ` — paid through ${paidThrough}` : ""}`
        : "Ongoing Weekly: OFF"}
    </button>
  );
};

export default WeeklyOngoingToggle;
